import { IRatingScale } from "models/RatingScaleModel";
import { BaseService } from "./base.service";

class RatingScaleServiceInternal extends BaseService {
	getRatingScaleList = async (): Promise<IRatingScale[]> =>
		this.callApi<IRatingScale[]>(`RatingScale/GetAll`, "GET");
}

export const RatingScaleService = new RatingScaleServiceInternal();
